import { message } from 'antd'
import {
  Auth0ErrorCode,
  useObserverCreateMutation,
  useObserverDeleteMutation,
  useObserversQuery,
  useObserverUpdateMutation,
} from 'lib/graphql/storeadmin'

type userInfo = {
  username?: string
  email?: string
  password?: string
}

export const useObserver = () => {
  // Graphql
  const { data, loading, refetch } = useObserversQuery()
  const [observerDeleteMutation] = useObserverDeleteMutation({
    onCompleted: () => {
      refetch()
    },
  })
  const [observerCreateMutation] = useObserverCreateMutation({
    onCompleted: () => {
      refetch()
    },
  })
  const [observerUpdateMutation] = useObserverUpdateMutation({
    onCompleted: () => {
      refetch()
    },
  })

  // オブザーバーの削除の関数
  const observerDelete = async (id: string) => {
    try {
      await observerDeleteMutation({
        variables: {
          auth0Id: id,
        },
      })
      message.success('オブザーバーを削除しました。')
    } catch (error) {
      message.error('削除に失敗しました。')
    }
  }

  // オブザーバーの追加の関数
  const observerAdd = async (info: userInfo) => {
    const observerInfo = {
      userName: info.username,
      password: info.password,
      email: info.email,
    }
    try {
      const { data } = await observerCreateMutation({
        variables: observerInfo,
      })

      if (data?.observerCreate.authUserError !== null) {
        const errorCode = data?.observerCreate.authUserError.code
        const errorMessage = data?.observerCreate.authUserError.message
        const reasonForInvalidPassword =
          data?.observerCreate.authUserError.reasonForInvalidPassword

        if (errorCode === Auth0ErrorCode.InvalideRequest)
          message.error('不正なリクエストです。')

        if (errorCode === Auth0ErrorCode.InvalidPassword) {
          message.error('パスワードの条件を満たしていません。')
          message.error(reasonForInvalidPassword)
        }

        if (errorMessage === 'The user already exists.')
          message.error('既に登録されているユーザーです。')
        // message.error(errorCode)
        // message.error(errorMessage)
        return
      }
      message.success('オブザーバーを追加しました。')
    } catch (error) {
      message.error('オブザーバーの追加時にエラーが発生しました。')
    }
  }

  // オブザーバーの編集
  const observerUpdate = async (info: userInfo, observerId: string) => {
    const observerInfo = {
      userName: info.username,
      password: null,
      email: info.email,
    }

    try {
      await observerUpdateMutation({
        variables: {
          auth0UserId: observerId,
          observerInput: observerInfo,
        },
      })

      message.success('オブザーバー情報を更新しました。')
    } catch (error) {
      message.error('オブザーバー情報の更新に失敗しました。')
    }
  }

  return {
    data,
    loading,
    observerAdd,
    observerDelete,
    observerUpdate,
  }
}
